
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.77043 11.3997L19.3331 15.8559C20.1332 16.0712 20.9567 15.5995 21.1759 14.8005C21.397 13.9941 20.9185 13.162 20.1104 12.9475L14.8105 11.5408L12.0481 2.5048L10.1126 1.99902V10.2861L5.16173 8.95352L4.22798 6.63859L2.77043 6.24953V11.3997ZM3.5 19.0004C2.94771 19.0004 2.5 19.4482 2.5 20.0004C2.5 20.5527 2.94772 21.0004 3.5 21.0004H20.5C21.0523 21.0004 21.5 20.5527 21.5 20.0004C21.5 19.4482 21.0523 19.0004 20.5 19.0004H3.5Z","fill":"#262D33"}})])
          )
        }
      }
    